/**
 * Shared WOM star renderer — matches product card Font Awesome solid star.
 * Keep in sync with wom-jsx/src/womStars.js
 */
(function () {
  var WOM_STAR_VIEWBOX = "0 0 576 512";
  var WOM_STAR_PATH =
    "M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z";
  var WOM_STAR_FILLED = "#000000";
  var WOM_STAR_EMPTY = "#d4d4d4";

  function getStarParts(rating) {
    var value = Math.max(0, Math.min(5, parseFloat(rating) || 0));
    var full = Math.floor(value);
    var decimalPart = value - full;
    var partial = decimalPart > 0 ? Math.round(decimalPart * 100) : 0;
    return { value: value, full: full, partial: partial };
  }

  function renderWomStarSvgHtml(options) {
    var filled = options.filled !== false;
    var partialPercent = options.partialPercent || 0;
    var size = options.size || 17;
    var uid = options.uid || "0";
    var gradId = "wom-star-partial-" + uid + "-" + partialPercent;
    var style = "display:block;flex-shrink:0";

    if (filled) {
      return (
        '<svg viewBox="' +
        WOM_STAR_VIEWBOX +
        '" width="' +
        size +
        '" height="' +
        size +
        '" style="' +
        style +
        '" aria-hidden="true"><path fill="' +
        WOM_STAR_FILLED +
        '" d="' +
        WOM_STAR_PATH +
        '"/></svg>'
      );
    }

    if (partialPercent > 0) {
      return (
        '<svg viewBox="' +
        WOM_STAR_VIEWBOX +
        '" width="' +
        size +
        '" height="' +
        size +
        '" style="' +
        style +
        '" aria-hidden="true"><defs><linearGradient id="' +
        gradId +
        '" x1="0%" y1="0%" x2="100%" y2="0%"><stop offset="0%" stop-color="' +
        WOM_STAR_FILLED +
        '"/><stop offset="' +
        partialPercent +
        '%" stop-color="' +
        WOM_STAR_FILLED +
        '"/><stop offset="' +
        partialPercent +
        '%" stop-color="' +
        WOM_STAR_EMPTY +
        '"/><stop offset="100%" stop-color="' +
        WOM_STAR_EMPTY +
        '"/></linearGradient></defs><path fill="url(#' +
        gradId +
        ')" d="' +
        WOM_STAR_PATH +
        '"/></svg>'
      );
    }

    return (
      '<svg viewBox="' +
      WOM_STAR_VIEWBOX +
      '" width="' +
      size +
      '" height="' +
      size +
      '" style="' +
      style +
      '" aria-hidden="true"><path fill="' +
      WOM_STAR_EMPTY +
      '" d="' +
      WOM_STAR_PATH +
      '"/></svg>'
    );
  }

  function renderWomStarsHtml(rating, size) {
    var parts = getStarParts(rating);
    var px = size || 17;
    var baseId = "wom-" + Math.random().toString(36).slice(2, 8);
    var html = "";
    var i;

    for (i = 0; i < 5; i++) {
      var uid = baseId + "-" + i;
      if (i < parts.full) html += renderWomStarSvgHtml({ filled: true, size: px, uid: uid });
      else if (i === parts.full && parts.partial > 0)
        html += renderWomStarSvgHtml({ filled: false, partialPercent: parts.partial, size: px, uid: uid });
      else html += renderWomStarSvgHtml({ filled: false, size: px, uid: uid });
    }

    return html;
  }

  function buildWomCardStarHtml(size) {
    return renderWomStarSvgHtml({ filled: true, size: size || 15, uid: "card" });
  }

  window.WOMStars = {
    renderWomStarsHtml: renderWomStarsHtml,
    buildWomCardStarHtml: buildWomCardStarHtml,
    renderWomStarSvgHtml: renderWomStarSvgHtml,
  };
  window.renderWomStars = renderWomStarsHtml;
  window.buildWomCardStarHtml = buildWomCardStarHtml;
})();
